const { useState } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, PanelRow, TextControl, SelectControl, ToggleControl } =
  wp.components;
import CommonPanel from '../wp-controlers/common-panel';
import { addTabActive } from './functions/changeTab';

export default function Inspector({ attributes, setAttributes }) {
  const { tabsHeading, variant, containerized } = attributes;

  const tabsOptions = tabsHeading.map((heading) => {
    return { label: heading.title, value: heading.tabId };
  });

  const [title, setTitle] = useState();
  const [tabId, setTabId] = useState();

  const [tabToDelete, setTabToDelete] = useState(tabsOptions[0]);

  function verifyIfValueExists() {
    return tabsHeading.filter((heading) => heading.tabId === tabId).length > 0;
  }

  function registerNewTab() {
    if (!title || !tabId) return;

    const alreadyCreated = verifyIfValueExists();
    if (alreadyCreated) return;

    const newTab = { title, tabId };

    const currentHeadings = tabsHeading;
    currentHeadings.push(newTab);

    setTabId('');
    setTitle('');
    setAttributes({
      tabsHeading: [...currentHeadings],
    });

    document
      .querySelector('.components-button[aria-label="Adicionar Guia"]')
      .click();

    setTimeout(addTabActive, 1000);
  }

  function deleteTab(tabToDeleteId) {
    const filteredTabs = tabsHeading.filter(
      (tab) => tab.tabId !== tabToDeleteId
    );

    setAttributes({ tabsHeading: filteredTabs });
    return filteredTabs;
  }

  window.onload = () => addTabActive();

  // TODO: add url id obligatory if length > 0
  return (
    <InspectorControls>
      <PanelBody title={'Atributos do componente'} initialOpen={true}>
        <SelectControl
          label="Selecione o estilo de guia"
          title="Selecione o estilo de guia"
          value={variant}
          options={[
            {
              label: 'Default',
              value: 'default',
            },
            {
              label: 'Fundo azul',
              value: 'bg-blue-normal',
            },
            {
              label: 'Fundo azul grande',
              value: 'bgBlue',
            },
          ]}
          onChange={(position) => setAttributes({ variant: position })}
        />

        <ToggleControl
          label="Alinhar no container?"
          checked={containerized}
          onChange={() => setAttributes({ containerized: !containerized })}
        />
      </PanelBody>

      <PanelBody title={'Registrar guia'} initialOpen={true}>
        <TextControl
          label={'Titulo da guia'}
          value={title}
          onChange={(sentTitle) => setTitle(sentTitle)}
        />

        <TextControl
          label={'ID da guia (Não pode ser alterado posteriormente)'}
          value={tabId}
          onChange={(tabId) => setTabId(tabId)}
        />

        <PanelRow>
          <button className="Button" onClick={registerNewTab}>
            Registrar nova guia
          </button>
        </PanelRow>
      </PanelBody>

      <PanelBody title={'Excluir guia'} initialOpen={false}>
        <SelectControl
          label={'Qual guia quer excluir?'}
          value={tabToDelete}
          options={tabsOptions}
          onChange={(selectedTab) => setTabToDelete(selectedTab)}
        />

        <PanelRow>
          <button className="Button" onClick={() => deleteTab(tabToDelete)}>
            Apagar guia
          </button>
        </PanelRow>
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
}
